import { useEffect, useState } from 'react';

const useSessionStorageInfo = () => {
  const [redirect_uri, setRedirectURI] = useState('');
  const [postParent, setPostParent] = useState(false);
  const [clientId, setClientId] = useState('');
  const [ssoLink, setSsoLink] = useState('');
  const [app_id, setAppId] = useState('');
  const [tenantData, setTenantData] = useState({
    _id: '',
    tenantName: '',
    logo: '',
    linkedin: false,
    sso: false,
  });

  useEffect(() => {
    if (typeof window !== 'undefined') {
      try {
        const stringifyData = window.sessionStorage.getItem('tenant');
        // Standardize on redirect_uri but support redirecturl for backward compatibility
        const redirect_uri_stored = window.sessionStorage.getItem('redirect_uri');
        const redirecturl_stored = window.sessionStorage.getItem('redirecturl');
        const redirect_uri_value = redirect_uri_stored || redirecturl_stored || '';
        const postParent = window.sessionStorage.getItem('postParent');
        const clientId = window.sessionStorage.getItem('clientId');
        const ssoLink = window.sessionStorage.getItem('ssoLink');
        const app_id = window.sessionStorage.getItem('app_id');
        setClientId(clientId ? clientId : '');
        setPostParent(postParent != null);
        setRedirectURI(redirect_uri_value);
        setSsoLink(ssoLink ? ssoLink : '');
        setTenantData(
          stringifyData !== null ? JSON.parse(stringifyData) : null
        );
        setAppId(app_id ? app_id : '');
      } catch (error) {
        // Handle parsing error
        console.error('Error parsing tenant data:', error);
        // Optionally, you can clear sessionStorage if the data is corrupted
        // window.sessionStorage.removeItem('tenant');
      }
    }
  }, []);

  return {
    tenantData,
    redirect_uri,
    // Keep redirecturl for backward compatibility but it's the same value
    redirecturl: redirect_uri,
    postParent,
    setTenantData,
    clientId,
    ssoLink,
    app_id,
  };
};
export default useSessionStorageInfo;
